import { Clock, AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "@/shared/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/shared/ui/Dialog";

type InactivityDialogProps = {
  open: boolean
  message: string
  warningLevel: "first_warning" | "second_warning" | null
  isHandlingActivity: boolean
  countdown: number | null
  onClose: () => void
};

const InactivityDialog = ({
  open, message, warningLevel, isHandlingActivity, countdown, onClose,
}: InactivityDialogProps) => {
  const isSecondWarning = warningLevel === "second_warning";

  const formatCountdown = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <Dialog open={open} onOpenChange={() => {}} modal>
      <DialogContent className="sm:max-w-md" showClose={false}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg font-semibold">
            {isSecondWarning
              ? (
                <AlertTriangle className="w-5 h-5 text-red-500" />
              )
              : (
                <Clock className="w-5 h-5 text-orange-500" />
              )}
            {isSecondWarning ? "Déconnexion imminente" : "Inactivité détectée"}
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">
          <p className="text-gray-700">{message}</p>
          {isSecondWarning && countdown !== null && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <div className="flex items-center justify-between">
                <span className="text-red-700 font-medium">Déconnexion automatique dans :</span>
                <span className="text-red-600 font-bold text-lg">
                  {formatCountdown(countdown)}
                </span>
              </div>
            </div>
          )}
        </div>

        <DialogFooter>
          <Button
            onClick={onClose}
            disabled={isHandlingActivity}
            className={`w-full sm:w-auto ${
              isSecondWarning
                ? "bg-red-500 hover:bg-red-600 text-white disabled:bg-red-300"
                : "bg-indigo-400 hover:bg-indigo-500 text-white disabled:bg-indigo-300"
            }`}
          >
            {isHandlingActivity
              ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Confirmation...
                </>
              )
              : (
                "Je suis toujours là"
              )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InactivityDialog;
